import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import SettingsSectionHeading from './settings-section-heading'

interface SettingsSectionHeadingProps {
  children: ReactNode
  headingTitle: string
  className?: string
  classNameTitle?: string
}

export const SettingsSection = ({
  children,
  headingTitle,
  className,
  classNameTitle,
}: SettingsSectionHeadingProps) => {
  return (
    <div className={twMerge('flex max-w-full flex-col gap-4', className)}>
      <SettingsSectionHeading className={classNameTitle}>{headingTitle}</SettingsSectionHeading>
      {children}
    </div>
  )
}
